// The line at the top of the Library after a login from the report link (Adam, 30 Oct 2026; reportLanding.js): the
// report is ready, and 1 button opens it. Shown only when the landing was marked, the person really has a saved report
// (their own latest row, under row level security, as the report page reads it) and staff aren't viewing as them. No
// saved report, or a read that fails, clears the mark and shows nothing. In the payment banner's look, with no icon.
import { useEffect, useState } from 'react'
import { Link } from '../lib/router.jsx'
import { loadSavedStrategy } from '../free/load.js'
import { REPORT_PATH } from '../strategy/route.js'
import { hasReportLanding, clearReportLanding, REPORT_READY } from './reportLanding.js'

export function ReportReady({ personId, phone, viewingAs }) {
  const [show, setShow] = useState(false)
  useEffect(() => {
    if (viewingAs || !personId || !hasReportLanding()) return undefined
    let live = true
    loadSavedStrategy(personId)
      .then(row => {
        if (!live) return
        if (row) setShow(true)
        else clearReportLanding()
      })
      .catch(() => { if (live) clearReportLanding() })
    return () => { live = false }
  }, [personId, viewingAs])

  if (!show) return null
  return (
    <div className={phone ? 'lib-banner lib-banner--phone lib-banner--report' : 'lib-banner lib-banner--report'}>
      <div className="lib-banner-text"><span>{REPORT_READY.text}</span></div>
      <Link to={REPORT_PATH} className="lib-banner-btn" onClick={clearReportLanding}>{REPORT_READY.button}</Link>
    </div>
  )
}
